import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import InnerHero from "../components/InnerHero";
import { Calendar, Users, Award, Beaker, CheckCircle2, Sparkles } from "lucide-react";

const associations = [
  {
    id: "ieee",
    name: "Institute of Electrical and Electronics Engineers (IEEE)",
    short: "IEEE",
    image: "/professional-body/7.png",
    established: "2020",
    department: "KLS VDIT IEEE Student Branch",
    coordinator: "Student Branch Chair, Vice Chair, Treasurer and Volunteer Coordinator",
    email: "info@klsvdit.edu.in",
    overview:
      "IEEE is a reflection of countless journeys, shaped by learning, collaboration, and inspiration. KLS VDIT's association with IEEE began in 2020 by forming a Student Branch, and what began as a step toward exploring technical opportunities evolved into a journey of growth, leadership, meaningful connections, and professional development.",
    sectionTitles: {
      objectives: "Why IEEE",
      activities: "Events",
      team: "Execom",
      achievements: "Achievements",
    },
    objectives: [
      "Exposure to real-world technologies.",
      "Opportunities beyond academics.",
      "A platform to connect with academicians and industry people.",
      "A community that nurtures growth, innovation, collaboration and lifelong learning.",
    ],
    activities: [
      "Technical workshops, hackathons and hands-on projects.",
      "Expert talks from industry leaders.",
      "National-level hackathon initiatives that encourage teamwork, responsibility and practical problem solving.",
      "Virtual conferences, webinars, online competitions and collaborative projects.",
    ],
    team: [
      "Student Branch Chair, Vice Chair, Treasurer and Volunteer Coordinator roles help students practice leadership.",
      "Students build team management, event planning, communication and networking skills.",
      "The culture of volunteerism encourages members to step forward, take initiative and make a difference.",
      "Members connect with peers passionate about technology, mentors who guide and inspire, and industry professionals sharing real-world insights.",
    ],
    achievements: [
      "IEEE Bangalore Section supports student branches across Karnataka, organizes high-quality conferences and technical events, and promotes academia-industry collaboration.",
      "IEEE Mangalore Subsection has supported the branch's journey of learning, growth and inspiration.",
      "Digital and hybrid engagement expanded access through virtual conferences, webinars, online competitions and collaborative projects.",
      "The branch envisions stronger work in emerging technologies, industry-academia partnerships, student opportunities, young professional engagement and outreach for societal impact.",
    ],
  },

  {
    id: "csi",
    name: "Computer Society of India (CSI)",
    short: "CSI",
    image: "/professional-body/1.png",
    established: "Content to be updated",
    department: "Computer Science & Engineering",
    coordinator: "Content to be updated",
    email: "info@klsvdit.edu.in",
    overview:
      "The CSI chapter at KLS VDIT provides a platform for students to explore computing, software development, emerging technologies, and professional practices through technical interactions, workshops, peer learning, and student-led activities. The association encourages students to move beyond classroom learning by engaging with programming concepts, industry trends, project ideas, and collaborative problem solving. Through seminars, coding activities, invited talks, and hands-on sessions, CSI helps students build confidence in applying computing knowledge to practical and professional contexts.",
    certificates: [
      {
        title: "CSI Institutional Membership",
        image: "/Association_images/CSI_Institutional_Membership.jpg",
      },
      {
        title: "CSI Student Chapter",
        image: "/Association_images/CSI_Student_Chapter.jpg",
      },
    ],
    objectives: ["Content to be updated."],
    activities: ["Content to be updated."],
    team: ["Content to be updated."],
    achievements: ["Content to be updated."],
  },

  {
    id: "acm",
    name: "Association for Computing Machinery (ACM)",
    short: "ACM",
    image: "/professional-body/4.png",
    established: "Content to be updated",
    department: "Computer Science & Engineering",
    coordinator: "Content to be updated",
    email: "info@klsvdit.edu.in",
    overview:
      "The ACM student community at KLS VDIT encourages students to strengthen their foundations in computer science through programming activities, technical discussions, research exposure, collaborative learning, and participation in computing-focused events. It offers students opportunities to engage with areas such as algorithms, software systems, artificial intelligence, data science, cybersecurity, and emerging computing practices. The forum also promotes teamwork, technical curiosity, peer mentoring, and participation in competitions, helping students develop both academic depth and professional readiness.",
    objectives: ["Content to be updated."],
    activities: ["Content to be updated."],
    team: ["Content to be updated."],
    achievements: ["Content to be updated."],
  },

  {
    id: "iste",
    name: "Indian Society for Technical Education (ISTE)",
    short: "ISTE",
    image: "/professional-body/3.png",
    established: "Content to be updated",
    department: "Content to be updated",
    coordinator: "Content to be updated",
    email: "info@klsvdit.edu.in",
    overview:
      "The ISTE chapter supports the professional growth of students and faculty by promoting technical education, teaching-learning innovation, skill development, leadership, workshops, seminars, and academic enrichment activities. It creates opportunities for learners and educators to stay connected with advances in engineering education, pedagogical practices, communication skills, and professional ethics. Through training programmes, expert lectures, student development initiatives, and collaborative events, ISTE contributes to a culture of continuous learning and holistic technical development.",
    objectives: ["Providing quality training programmes to teachers and administrators of technical institutions to update their knowledge and skills in their fields of activity. To assist and contribute in the production and development of top quality professional engineers and technicians needed by the industry and other organisations. Providing guidance and training to students to develop better learning skills and personality."],
    featureImage: {
      title: "ISTE Certificate",
      image: "/ISTE/Images/ISTE CERTIFICATE.png",
    },
    tables: [
      {
        title: "LIST OF ISTE OFFICE BEARERS 2025-2026",
        columns: ["SL.NO", "DESIGNATION", "STUDENT INCHARGES", "BRANCH"],
        rows: [
          ["1", "Chairperson", "Karthik Kalayanshetti", "ECE"],
          ["2", "Vice chairperson", "Pavan Narayan Javalekar", "ECE"],
          ["3", "Secretary", "Shweta M Chinagi", "EEE"],
          ["4", "Treasurer", "Laxmi K. Kammar", "CV"],
          ["5", "Executive Council Members", "Giridhar V Sangappanavar", "ME"],
        ],
      },
      {
        title: "LIST OF ISTE COMMITTEE MEMBERS 2025-2026",
        columns: ["SL.NO", "NAME", "BRANCH"],
        rows: [
          ["1", "Prof. Sudhendra Y", "ECE"],
          // ["2", "", "EEE", ],
          ["2", "Prof. Chandrakant Patil", "ME"],
          ["3", "Prof. Seema Basarikatti", "CV"],
        ],
      },
    ],
    activityTables: [
      {
        title: "TENTATIVE ACTION PLAN",
        columns: ["Sl.no", "Activity", "Objective", "Target Participants", "Time line"],
        rows: [
          ["1", "Technical Seminar / Expert Lecture", "Exposure to emerging technologies", "Students & Faculty", "Jan- June 2026"],
          ["2", "Workshop / Hands-on Training", "Skill development in core and advanced areas", "Students", "Jan- June 2026"],
          ["3", "Faculty Development Programme (FDP)", "Faculty Development Programme (FDP)", "Faculty Development Programme (FDP)", "July-Dec 2026"],
          ["4", "Industry Interaction / Industrial Visit", "Industry Interaction / Industrial Visit", "Industry Interaction / Industrial Visit", "July-Dec 2026"],
        ],
      },
    ],
    activities: {
      reports: [
        { label: "Nextgen AI Users Competition Report", href: "/ISTE/Report/Nextgen-AI-users-competition_report.pdf" },
        { label: "Ultratech Event Report", href: "/ISTE/Report/ultratech-event-report.pdf" },
      ],
    },
  },

  {
    id: "iei",
    name: "Institution of Engineers (India)",
    short: "IEI",
    image: "https://images.pexels.com/photos/159306/construction-site-build-construction-work-159306.jpeg?w=2400",
    established: "To be updated",
    department: "KLS VDIT IEI Chapter",
    coordinator: "Faculty Coordinator and Student Coordinators",
    email: "info@klsvdit.edu.in",
    overview:
      "The Institution of Engineers (India) or IEI is the largest multidisciplinary professional body that encompasses 15 engineering disciplines and gives engineers a global platform from which to share professional interest. IEI has membership strength of over 0.8 million. Established in 1920, with its headquarters at 8 Gokhale Road, Kolkata – 700020, IEI has served the engineering fraternity for over nine decades. In this period of time, it has been inextricably linked with the history of modern-day engineering.",
    overviewExtra:
      "In 1935, IEI was incorporated by Royal Charter and remains the only professional body in India to be accorded this honor. Today, its quest for professional excellence has given it a place of pride in almost every prestigious and relevant organization across the globe. IEI functions among professional engineers, academicians and research workers. It provides a vast array of technical, professional and supporting services to the Government, Industries, Academia and the Engineering fraternity, operating from 120 Centers located across the country. The Institution has established R&D Centers at various locations in the country and also provides grant-in-aid to its members to conduct research and development on engineering subjects.",
    certificates: [
      { title: "IEI Mechanical Engineering Certificate", image: "/IEI_certificates/ME.jpg" },
      { title: "IEI Electronics & Communication Engineering Certificate", image: "/IEI_certificates/ECE.jpg" },
      { title: "IEI Electrical & Electronics Engineering Certificate", image: "/IEI_certificates/EEE.jpg" },
    ],
    sections: [
      {
        id: "membership",
        title: "IEI Membership Details",
        icon: Users,
        items: [
          "KLS VDIT Haliyal is an active member institute of IEI with Institutional Membership ID: IM000303-6.",
          "Student Chapter ID: 581329/VDIT/EC",
          "581329/VDIT/EE",
          "581329/VDIT/ME",
          "Number of Students Membership: 110",
        ],
      },
      {
        id: "vision",
        title: "The Vision of IEI",
        icon: CheckCircle2,
        items: [
          "IEI aims to be a leading global professional society for engineers and scientists, focusing on professional development and sustainable technological growth.",
        ],
      },
      {
        id: "mission",
        title: "The Mission of IEI",
        icon: Calendar,
        items: [
          "The IEI mission centers on advancing engineering and technology, facilitating knowledge exchange, and providing value-based services to the nation.",
        ],
      },
      {
        id: "core-objectives",
        title: "Core Objectives & Implementation",
        icon: Users,
        items: [
          "The organization fulfills its mission through practical initiatives managed via its various state centers and student chapters.",
          "R&D Initiatives: Providing grant-in-aid support to research scholars to foster engineering innovation.",
          "Professional Platforms: Organizing national and international seminars, workshops, and technical programs.",
          "Peer-Reviewed Publications: Collaborating with global publishers to release high-quality journals covering 15 distinct engineering disciplines.",
          "Professional Certifications: Issuing standard industry credentials including Chartered Engineer, Professional Engineer, and International Professional Engineer certifications.",
        ],
      },
    ],
    achievements: [
      "Received Prestigious Engineering Education Excellence Award for the Year 2025.",
      "Students of Mechanical Engineering Received Funding for Students Research Project Proposal 2026-2027 Under the Guidance od Dr. Shankar Badiger.",
      "Prof. S. D. Kulkarni Delivered Technical Talk on 'Industry 5.0: Vikasit Bharat' on 26-05-2026 at IEI Dharwad Local Centre",
    ],
  },

  {
    id: "bites",
    name: "Board for IT Education Standards (BITES)",
    short: "BITES",
    image: "/professional-body/6.png",
    established: "Content to be updated",
    department: "Content to be updated",
    coordinator: "Content to be updated",
    email: "info@klsvdit.edu.in",
    certificates: [
      {
        title: "Certificate of Membership",
        image: "/Association_images/BITES.png",
      },
    ],
    overview:
      "BITES at KLS VDIT connects students with IT education standards, industry expectations, employability skills, technology awareness, and collaborative learning opportunities that help bridge academic knowledge with professional practice. The platform supports exposure to current trends in the IT sector, software development practices, industry-oriented problem statements, and skill-building activities. By encouraging student participation in technical events, knowledge-sharing sessions, and industry-aligned programmes, BITES helps learners understand how classroom concepts translate into workplace expectations.",
    objectives: ["Content to be updated."],
    activities: ["Content to be updated."],
    team: ["Content to be updated."],
    achievements: ["Content to be updated."],
  },

  {
    id: "iic",
    name: "Institution's Innovation Council (IIC)",
    short: "IIC",
    image: "/professional-body/5.png",
    established: "Content to be updated",
    department: "Innovation Hub",
    coordinator: "Content to be updated",
    email: "info@klsvdit.edu.in",
    overview:
      "The Institution's Innovation Council at KLS VDIT promotes innovation, entrepreneurship, idea generation, prototyping, startup awareness, and problem-solving activities that encourage students to transform creative ideas into practical solutions. The council nurtures an innovation mindset by guiding students through ideation, design thinking, proof-of-concept development, mentorship, and exposure to startup ecosystems. Through workshops, innovation challenges, awareness sessions, and project-based activities, IIC helps students develop confidence to identify real-world problems and build impactful solutions.",
    imageGallery: [
      { title: "IIC Appreciation Letter", image: "/IIC/Images/IIC Appreciation-Letter.jpeg" },
      { title: "IIC Certificate", image: "/IIC/Images/IIC CERTIFICATE.jpg" },
    ],
    objectives: [],
    activities: {
      reports: [
        { label: "Start-up Opportunities in Artificial Intelligence & Machine Learning", href: "/IIC/Reports/IIC_Q1_01_Start-up-Opportunities-in-Artificial-Intelligence-Machine-Learning.pdf" },
        { label: "Cyber Security", href: "/IIC/Reports/IIC_Q1_02_Cyber-Security.pdf" },
        { label: "Q2 Activity Report", href: "/IIC/Reports/IIC_Q2-_INDEX.pdf" },
        { label: "IC-Design using Cadence", href: "/IIC/Reports/IIC_Q3_01_Hands-on-workshop-on-IC-Design-using-Cadence.pdf" },

      ],
    },
  },
];

const Section = ({ id, title, icon: Icon, children }) => (
  <section id={id} className="scroll-mt-32">
    <h3
      className="text-2xl md:text-3xl text-brand font-semibold flex items-center gap-2 mb-5"
      style={{ fontFamily: "'Cormorant Garamond', serif" }}
    >
      {Icon && <Icon size={22} />} {title}
    </h3>
    {children}
  </section>
);

const InfoItem = ({ icon: Icon, text }) => (
  <li className="flex items-start gap-3 bg-white p-4 border border-brand/15">
    <Icon size={18} className="text-brand flex-shrink-0 mt-0.5" />
    <span className="text-[15px] text-[#2a2a2a]">{text}</span>
  </li>
);

const ImagePanel = ({ image }) => (
  <figure className="bg-white border border-brand/15 p-5 overflow-hidden">
    <img
      src={image.image}
      alt={image.title}
      className="w-full max-h-[760px] object-contain bg-white"
      loading="lazy"
    />
  </figure>
);

const DataTable = ({ table }) => (
  <div className="bg-white border border-brand/15 overflow-x-auto">
    <h4 className="text-center text-lg md:text-xl font-semibold underline py-4 text-black">
      {table.title}
    </h4>
    <table className="w-full min-w-[720px] text-sm text-black">
      <thead>
        <tr>
          {table.columns.map((column) => (
            <th key={column} className="border border-black px-3 py-2 text-center font-semibold">
              {column}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {table.rows.map((row, rowIndex) => (
          <tr key={`${table.title}-${rowIndex}`}>
            {row.map((cell, cellIndex) => (
              <td
                key={`${table.title}-${rowIndex}-${cellIndex}`}
                className="border border-black px-3 py-2 text-center align-middle"
              >
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const ActivityReports = ({ reports }) => (
  <ul className="space-y-2">
    {reports.map((report, index) => (
      <li key={`${report.label}-${index}`} className="bg-white border border-brand/15">
        <a
          href={report.href}
          className="flex items-center gap-3 p-4 text-[15px] text-[#2a2a2a] hover:text-brand"
          target={report.href === "#" ? undefined : "_blank"}
          rel={report.href === "#" ? undefined : "noreferrer"}
        >
          <Calendar size={18} className="text-brand flex-shrink-0" />
          <span>{report.label}</span>
        </a>
      </li>
    ))}
  </ul>
);

const AssociationDetail = () => {
  const { id } = useParams();
  const association = associations.find((item) => item.id === id);
  const isIeee = association?.id === "ieee";
  const isIei = association?.id === "iei";
  const isIic = association?.id === "iic";
  const isIste = association?.id === "iste";

  if (!association) {
    return <Navigate to="/associations" replace />;
  }

  const activityItems = Array.isArray(association.activities) ? association.activities : [];
  const activityReports = Array.isArray(association.activities?.reports)
    ? association.activities.reports
    : [];
  // Quick facts is intentionally hidden for ISTE and IIC.
  const showQuickFacts = !isIste && !isIic;

  const ieeeNavItems = [
    { label: "Home", type: "hash", href: "#overview" },
    { label: "About Us", type: "route", to: "/associations/ieee/about-us" },
    { label: "Events", type: "hash", href: "/associations/ieee/events" },
    { label: "Achievements", type: "hash", href: "#achievements" },
    { label: "Execom", type: "hash", href: "/associations/ieee/execom" },
    { label: "Contact Us", type: "hash", href: "#overview" },
  ];

  const ieiNavItems = [
    { label: "Overview", type: "hash", href: "#overview" },
    association.certificates?.length > 0 && { label: "Certificates", type: "hash", href: "#certificates" },
    //{ label: "Membership", type: "hash", href: "#membership" },
    //{ label: "The Vision of IEI", type: "hash", href: "#vision" },
    //{ label: "The Mission of IEI", type: "hash", href: "#mission" },
    //{ label: "Core Objectives & Implementation", type: "hash", href: "#core-objectives" },
    { label: "Achievements", type: "hash", href: "#achievements" },
    { label: "Activities", type: "route", to: "/associations/iei/activities" },
    { label: "Faculty Members", type: "route", to: "/associations/iei/faculty-members" },
    { label: "Student Members", type: "route", to: "/associations/iei/student-members" },
  ].filter(Boolean);

  const defaultNavItems = [
    !isIic && { label: "Overview", type: "hash", href: "#overview" },
    association.certificates?.length > 0 && { label: "Certificates", type: "hash", href: "#certificates" },
    association.objectives?.length > 0 && { label: "Objectives", type: "hash", href: "#objectives" },
    (activityItems.length > 0 || activityReports.length > 0 || association.activityTables?.length > 0) && { label: "Activities", type: "hash", href: "#activities" },
    association.team?.length > 0 && { label: "Team", type: "hash", href: "#team" },
    association.achievements?.length > 0 && { label: "Achievements", type: "hash", href: "#achievements" },
  ].filter(Boolean);

  return (
    <main>
      <InnerHero
        title={association.name}
        image={association.image}
        breadcrumbs={[
          { label: "Associations & Innovation Hub", to: "/associations" },
          { label: association.short },
        ]}
      />

      <section className="bg-surface-alt/60 border-b border-brand/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 flex flex-wrap gap-x-6 gap-y-2 text-xs font-sans-ui font-semibold tracking-wider text-brand">
          {(isIeee ? ieeeNavItems : isIei ? ieiNavItems : defaultNavItems).map((item) =>
            item.type === "route" ? (
              <Link key={item.label} to={item.to} className="uppercase hover:underline">
                {item.label}
              </Link>
            ) : (
              <a key={item.label} href={item.href} className="uppercase hover:underline">
                {item.label}
              </a>
            )
          )}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <div className={showQuickFacts ? "grid lg:grid-cols-3 gap-10" : ""}>
          <div className={showQuickFacts ? "lg:col-span-2 space-y-12" : "space-y-12"}>
            <Section id="overview" title={association.name}>
              <p className="text-[#2a2a2a]/85 leading-relaxed text-[15.5px]">
                {association.overview}
              </p>
              {association.overviewExtra && (
                <p className="text-[#2a2a2a]/85 leading-relaxed text-[15.5px] mt-4">
                  {association.overviewExtra}
                </p>
              )}
            </Section>

            {association.certificates?.length > 0 && (
              <Section id="certificates" title="Certificates" icon={Award}>
                <div className="space-y-8">
                  {association.certificates.map((certificate) => (
                    <figure
                      key={certificate.title}
                      className="bg-white border border-brand/15 p-5 md:p-7 overflow-hidden"
                    >
                      <figcaption className="mb-5">
                        <span className="text-xs uppercase tracking-[0.35em] text-brand font-semibold font-sans-ui">
                          Association Certificate
                        </span>
                        <h4
                          className="text-2xl md:text-3xl text-brand font-semibold mt-1"
                          style={{ fontFamily: "'Cormorant Garamond', serif" }}
                        >
                          {certificate.title}
                        </h4>
                      </figcaption>
                      <img
                        src={certificate.image}
                        alt={certificate.title}
                        className="w-full max-h-[760px] object-contain bg-white border border-brand/10"
                        loading="lazy"
                      />
                    </figure>
                  ))}
                </div>
              </Section>
            )}

            {association.sections?.map((section) => (
              <Section
                key={section.id}
                id={section.id}
                title={section.title}
                icon={section.icon}
              >
                <ul className="space-y-2">
                  {(section.items || []).map((item) => (
                    <InfoItem key={item} icon={section.icon || CheckCircle2} text={item} />
                  ))}
                </ul>
              </Section>
            ))}

            {association.objectives?.length > 0 && (
              <Section
                id="objectives"
                title={association.sectionTitles?.objectives || "Objectives"}
                icon={CheckCircle2}
              >
                <ul className="space-y-2">
                  {association.objectives.map((item) => (
                    <InfoItem key={item} icon={CheckCircle2} text={item} />
                  ))}
                </ul>
              </Section>
            )}

            {association.featureImage && (
              <Section id="feature-image" title={association.featureImage.title} icon={Award}>
                <ImagePanel image={association.featureImage} />
              </Section>
            )}

            {association.tables?.length > 0 && (
              <Section id="iste-details" title="ISTE Details" icon={Users}>
                <div className="space-y-8">
                  {association.tables.map((table) => (
                    <DataTable key={table.title} table={table} />
                  ))}
                </div>
              </Section>
            )}

            {isIic && association.imageGallery?.length > 0 && (
              <div className="space-y-8">
                {association.imageGallery.map((image) => (
                  <ImagePanel key={image.title} image={image} />
                ))}
              </div>
            )}

            {(activityItems.length > 0 || activityReports.length > 0 || association.activityTables?.length > 0) && (
              <Section
                id="activities"
                title={association.sectionTitles?.activities || "Activities"}
                icon={Calendar}
              >
                {activityItems.length > 0 && (
                  <ul className="space-y-2">
                    {activityItems.map((item) => (
                      <InfoItem key={item} icon={Calendar} text={item} />
                    ))}
                  </ul>
                )}
                {activityReports.length > 0 && <ActivityReports reports={activityReports} />}
                {association.activityTables?.length > 0 && (
                  <div className="space-y-8 mt-6">
                    {association.activityTables.map((table) => (
                      <DataTable key={table.title} table={table} />
                    ))}
                  </div>
                )}
              </Section>
            )}

            {association.team?.length > 0 && (
              <Section
                id="team"
                title={association.sectionTitles?.team || "Faculty & Team"}
                icon={Users}
              >
                <ul className="space-y-2">
                  {association.team.map((item) => (
                    <InfoItem key={item} icon={Users} text={item} />
                  ))}
                </ul>
              </Section>
            )}

            {association.achievements?.length > 0 && (
              <Section
                id="achievements"
                title={association.sectionTitles?.achievements || "Achievements"}
                icon={Sparkles}
              >
                <ul className="space-y-2">
                  {association.achievements.map((item) => (
                    <InfoItem key={item} icon={Award} text={item} />
                  ))}
                </ul>
              </Section>
            )}
          </div>

          {showQuickFacts && (
            <aside className="space-y-5">
              <div className="bg-white border border-brand/15 p-5 lg:sticky lg:top-36 self-start">
                <h4 className="text-xs uppercase tracking-widest text-brand font-semibold font-sans-ui">
                  Quick Facts
                </h4>

                <div className="mt-3 space-y-3 text-sm">
                  <div>
                    Established: <strong>{association.established}</strong>
                  </div>
                  <div>
                    Department: <strong>{association.department}</strong>
                  </div>
                  <div>
                    Coordinator: <strong>{association.coordinator}</strong>
                  </div>
                  <div>
                    Email: <strong>{association.email}</strong>
                  </div>
                </div>

                <div className="mt-6 pt-5 border-t border-brand/10">
                  <h4 className="text-xs uppercase tracking-widest text-brand font-semibold font-sans-ui mb-3">
                    Other Associations
                  </h4>

                  <ul className="space-y-1.5">
                    {associations
                      .filter((item) => item.id !== association.id)
                      .map((item) => (
                        <li key={item.id}>
                          <Link
                            to={`/associations/${item.id}`}
                            className="text-sm text-[#2a2a2a] hover:text-brand flex items-start gap-1 leading-snug"
                          >
                            <Beaker size={12} className="text-brand flex-shrink-0 mt-0.5" />
                            <span>{item.name}</span>
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>

              </div>
            </aside>
          )}
        </div>
      </section>
    </main>
  );
};

export default AssociationDetail;
